export function getCookie(name: any) {
  var nameOfCookie = name + "=";
  var x = 0;
  while (x <= document.cookie.length) {
    var y = x + nameOfCookie.length;
    let endOfCookie = null;
    if (document.cookie.substring(x, y) === nameOfCookie) {
      if ((endOfCookie = document.cookie.indexOf(";", y)) === -1)
        endOfCookie = document.cookie.length;
      return unescape(document.cookie.substring(y, endOfCookie));
    }
    x = document.cookie.indexOf(" ", x) + 1;
    if (x === 0) break;
  }
  return "";
}

// 24시간 기준 쿠키 설정하기
// expiredays 후의 클릭한 시간까지 쿠키 설정
export function setCookie(name: any, value: any, expiredays: any) {
  var todayDate = new Date();
  todayDate.setDate(todayDate.getDate() + expiredays);
  document.cookie =
    name +
    "=" +
    escape(value) +
    "; path=/; expires=" +
    todayDate.toUTCString() +
    ";";
}

// 00:00 시 기준 쿠키 설정하기
// expiredays 의 새벽  00:00:00 까지 쿠키 설정
export function setCookieAt00(name: any, value: any, expiredays: any) {
  var todayDate: any = new Date();
  todayDate = new Date(
    parseInt(String(todayDate.getTime() / 86400000)) * 86400000 + 54000000
  );
  if (todayDate > new Date()) {
    expiredays = expiredays - 1;
  }
  todayDate.setDate(todayDate.getDate() + expiredays);
  document.cookie =
    name +
    "=" +
    escape(value) +
    "; path=/; expires=" +
    todayDate.toGMTString() +
    ";";
}

export function closeWinAt00(winName: any, expiredays: any) {
  setCookieAt00(winName, "off", expiredays);
  //var obj = eval("window." + winName);
  //obj.style.display = "none";
}
